import { render, staticRenderFns } from "./mobilePublicFooter.vue?vue&type=template&id=5de21fc9&scoped=true"
import script from "./mobilePublicFooter.vue?vue&type=script&lang=js"
export * from "./mobilePublicFooter.vue?vue&type=script&lang=js"
import style0 from "./mobilePublicFooter.vue?vue&type=style&index=0&id=5de21fc9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de21fc9",
  null
  
)

export default component.exports